import styled, { css } from 'styled-components'

const Thumbnail = styled.img`
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  opacity: ${props => {
    if (props.state === 'uploading') return 0.15
    if (props.hasError) return 0.15
    return 1
  }};
`
const FirstMsg = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.primary.main};
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
  bottom: 0;
  color: white;
  display: flex;
  font-size: 14px;
  height: 24px;
  justify-content: center;
  position: absolute;
  text-align: center;
  width: 100%;
`

const CircularContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -20px;
  margin-top: -22px;
`

const Preview = styled.div`
  ${({ theme, ...props }) => css`
    background-color: ${theme.palette.background.paper};
    border-radius: 9px;
    border: 1px solid ${props.hasError ? theme.palette.error.main : theme.palette.grey[400]};
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    height: 106px;
    width: 106px;
    position: relative;
    vertical-align: top;
    overflow: hidden;
  `}
`

export { Thumbnail, FirstMsg, CircularContainer, Preview }
